import i18n from '@/utils/i18n';
import React from 'react';
import { Banner, Button } from '@usepepper/sprout-kit-ui';
import { StyleProp, View, ViewStyle } from 'react-native';
import { useAui } from '@assistant-ui/store';
import { useOpenThread } from '@/experiences/sales-portal/domain/superintelligence/blocs/hooks/use-open-thread';
import { useSuperintelligenceContext } from '@/experiences/sales-portal/domain/superintelligence/containers/superintelligence-runtime-provider';

interface AgentThreadStatusBannerProps {
  style?: StyleProp<ViewStyle>;
}

export const AgentThreadStatusBanner: React.FC<
  AgentThreadStatusBannerProps
> = ({ style }) => {
  const aui = useAui();
  const { archived, threadId } = useOpenThread();
  const { refreshThread, runInFlight } = useSuperintelligenceContext();

  if (archived) {
    return (
      <View style={style}>
        <Banner tone="info">
          <Banner.Description>
            {i18n.t('sales_portal.superintelligence.archived_notice')}
          </Banner.Description>
          <Banner.Actions>
            <Button
              onPress={() => aui.threads.item({ id: threadId }).unarchive()}
              size="$sm"
              variant="secondary"
            >
              {i18n.t('sales_portal.superintelligence.unarchive')}
            </Button>
          </Banner.Actions>
        </Banner>
      </View>
    );
  }

  if (runInFlight) {
    return (
      <View style={style}>
        <Banner tone="info">
          <Banner.Description>
            {i18n.t('sales_portal.superintelligence.run_in_flight')}
          </Banner.Description>
          <Banner.Actions>
            <Button onPress={refreshThread} size="$sm" variant="secondary">
              {i18n.t('refresh')}
            </Button>
          </Banner.Actions>
        </Banner>
      </View>
    );
  }

  return null;
};
